"use strict";
/*
 * Created on 01 23 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultObjectConverter_1 = require("../../core/model/errors/conversions/ValidationResultObjectConverter");

var ValidationResultFlag_1 = require("../../core/model/errors/ValidationResultFlag");

var utils_1 = require("../../core/utils");

var NotificationDocConverter_1 = require("../documents/NotificationDocConverter");

var Notification_1 = require("../model/Notification");

var NotificationGroup_1 = require("../model/NotificationGroup");

var NotificationState_1 = require("../model/NotificationState");

var NotificationType_1 = require("../model/NotificationType");

var NotificationConverter_1 = require("./NotificationConverter");
/**
 * @author Jaroslav Sevcik
 * @author Tomas Leity
 */


var NotificationConverterImpl =
/*#__PURE__*/
function (_NotificationConverte) {
  _inherits(NotificationConverterImpl, _NotificationConverte);

  function NotificationConverterImpl(validationResultObjectConverter) {
    var _this;

    _classCallCheck(this, NotificationConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotificationConverterImpl).call(this));
    _this.validationResultObjectConverter = validationResultObjectConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NotificationConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var validationResult = this.validationResultObjectConverter.toObject(source, conversions);
      var document = null;

      if (!utils_1.Utils.isValueMissing(source.documentType)) {
        var converter = typescript_ioc_1.Container.get(NotificationDocConverter_1.NotificationDocConverter, {
          documentType: source.documentType
        });
        document = converter.toObject(source.document, conversions);
      }

      return new Notification_1.Notification(conversions.documentToClassId(source), validationResult.severity, validationResult.messageKey, validationResult.messageVariables, validationResult.userMessage, validationResult.entityId, source.flags ? conversions.asFlagSet(source.flags, ValidationResultFlag_1.ValidationResultFlag) : ValidationResultFlag_1.ValidationResultFlag.EMPTY_SET, source.userId, conversions.asEnum(source.type, NotificationType_1.NotificationType), conversions.toDate(source.eventDate), conversions.asEnumOpt(source.group, NotificationGroup_1.NotificationGroup), conversions.asEnum(source.state, NotificationState_1.NotificationState), source.lastChange ? conversions.toDate(source.lastChange) : null, this.convertDataMapToObject(source), source.documentType, document);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = this.validationResultObjectConverter.toDocument(source, conversions);
      var document = null;

      if (!utils_1.Utils.isValueMissing(source.documentType)) {
        var converter = typescript_ioc_1.Container.get(NotificationDocConverter_1.NotificationDocConverter, {
          documentType: source.documentType
        });
        document = converter.toDocument(source.document, conversions);
      }

      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        userId: source.userId,
        type: source.type,
        eventDate: conversions.fromDate(source.eventDate),
        group: source.group,
        state: source.state,
        lastChange: source.lastChange === null ? null : conversions.fromDate(source.lastChange),
        dataMap: this.convertDataMapToDocument(source),
        documentType: source.documentType,
        document: document
      });
      return result;
    }
    /**
     * Convert data map to object
     * @param source
     */

  }, {
    key: "convertDataMapToObject",
    value: function convertDataMapToObject(source) {
      var map = immutable_1.Map();

      if (source.dataMap) {
        Object.keys(source.dataMap).forEach(function (key) {
          map = map.set(key, source.dataMap[key]);
        });
      }

      return !map.isEmpty() ? map : null;
    }
    /**
     * Convert data map to document
     * @param source
     */

  }, {
    key: "convertDataMapToDocument",
    value: function convertDataMapToDocument(source) {
      if (!source.dataMap || source.dataMap.isEmpty()) {
        return null;
      }

      var doc = {};
      source.dataMap.forEach(function (value, key) {
        doc[key] = value;
      });
      return doc;
    }
  }]);

  return NotificationConverterImpl;
}(NotificationConverter_1.NotificationConverter);

NotificationConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultObjectConverter_1.ValidationResultObjectConverter])], NotificationConverterImpl);
exports.NotificationConverterImpl = NotificationConverterImpl;